import { ClientContract, ContractsTabProps, PAGES } from "@dune/types";
import { DataTable } from "@dune/ui";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetClientContracts } from "../../../api/queries/clients.queries";
import { contractsColumns } from "./contractTab/contractsColumns";

const ContractsTab: React.FC<ContractsTabProps> = ({ client }) => {
	const navigate = useNavigate();

	const {
		data: contractsData,
		isLoading,
		error,
	} = useGetClientContracts(
		client.id.toString(),
		client.clientType || undefined,
	);

	const columns = contractsColumns();

	const handleRowClick = (contract: ClientContract) => {
		navigate(PAGES.CONTRACTS.show.withParams(contract.id.toString()));
	};

	if (error) {
		const errMsg = error instanceof Error ? error.message : String(error);
		console.error("Failed to load contracts for client", client.id, errMsg);
		return (
			<div className="p-6">
				<div className="text-red-600">
					Une erreur est survenue lors du chargement des contrats.
				</div>
			</div>
		);
	}

	return (
		<div>
			<div className="flex items-center justify-between mb-6">
				<div className="text-2xl font-semibold text-gray-900">Contrats</div>
			</div>

			<DataTable
				data={contractsData?.data || []}
				columns={columns}
				isLoading={isLoading}
				onRowClick={handleRowClick}
				noResultsText="Aucun contrat"
			/>
		</div>
	);
};

export default ContractsTab;
